import { AllStop } from '@/types';
import { useMemo, useCallback } from 'react';
import { Table, TableColumn, TableInput } from '@kinesis/bungle/nursery';
import { Content } from '@kinesis/bungle';
import { noop } from 'lodash/fp';

const baseYears = [2030, 2035, 2040, 2045, 2050];

const determineYears = (allYears: boolean) => {
  if (!allYears) return baseYears;
  return Array.from(Array(26).keys()).map((v) => v + 2025);
};

const normaliseStopsTable = (v: AllStop | undefined, allYears: boolean) => {
  return determineYears(allYears).map((y) => ({
    year: y,
    value: (v?.stops ?? []).find((s) => s.year === y)?.value,
  }));
};

const StopTable = (props: StopTableProps) => {
  const { stops, allYears = false, heading, onChange = noop, unit } = props;
  const normal = useMemo(
    () => normaliseStopsTable(stops, allYears),
    [stops, allYears],
  );
  const onUpdate = useCallback(
    (year: number, _key: string, value: number) => {
      onChange({
        stops: (stops?.stops ?? [])
          .filter((v: any) => v?.year !== year)
          .concat([
            {
              year,
              value,
            },
          ]),
      });
    },
    [onChange, stops],
  );

  return (
    <Content border>
      <Table data={normal} header showGridLines border>
        <TableColumn
          heading='Year'
          renderItem={(item: any) => `${item.year}`}
          width='1fr'
        />
        <TableColumn
          heading={heading ?? 'Value'}
          padding='none'
          renderItem={(item: any) => (
            <TableInput
              editMode
              dataType='number'
              onEditModeChange={() => {}}
              value={item.value ?? ''}
              placeholder='No change'
              itemKey={item.year}
              column={'value'}
              onChange={onUpdate}
              units={unit}
            />
          )}
          width='1fr'
        />
      </Table>
    </Content>
  );
};

export type StopTableProps = {
  stops?: AllStop;
  unit?: string;
  allYears?: boolean;
  heading?: string;
  onChange?: (v: AllStop) => void;
};

export { StopTable };
